import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import { AnimatedText } from "../components/shared/AnimatedText";
import { AnimatedBlock } from "../components/shared/AnimatedBlock";
import { ContactIcon } from "../components/Contact/ContactIcon";
import { ContactForm } from "../components/Contact/ContactForm";
import { WHATSAPP_URL, COURSE_TITLES_I18N } from "../data/config";

export function ContactSection({ t, lang }) {
  return (
    <section id="contact" className="relative py-20" style={{ backgroundImage: "url('/images/vizitkart3.jpg')", backgroundSize: "cover", backgroundPosition: "center", backgroundAttachment: "scroll" }}>
      <div className="absolute inset-0 bg-white/80 backdrop-blur-sm" />
      <div className="relative z-10 container mx-auto px-4">
        <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-12">
          <div className="space-y-8">
            <AnimatedText text={t.contact.title} tag="h2" className="text-4xl md:text-5xl font-black text-blue-900" />
            <AnimatedBlock delay={80} className="flex items-center gap-4">
              <ContactIcon icon={Phone} />
              <div>
                <div className="font-bold text-gray-900">{t.contact.phone}</div>
                <a href={`tel:${t.contact.phone1}`} className="text-gray-700 hover:text-blue-900 transition-colors block">{t.contact.phone1}</a>
                <a href={`tel:${t.contact.phone2}`} className="text-gray-700 hover:text-blue-900 transition-colors block">{t.contact.phone2}</a>
              </div>
            </AnimatedBlock>
            <AnimatedBlock delay={140} className="flex items-center gap-4">
              <ContactIcon icon={Mail} />
              <div>
                <div className="font-bold text-gray-900">{t.contact.email}</div>
                <a href="mailto:codekloudacademy@gmail.com" className="text-gray-700 hover:text-blue-900 transition-colors">codekloudacademy@gmail.com</a>
              </div>
            </AnimatedBlock>
            <AnimatedBlock delay={200} className="flex items-center gap-4">
              <ContactIcon icon={MapPin} />
              <div>
                <div className="font-bold text-gray-900">{t.contact.location}</div>
                <div className="text-gray-700">{t.contact.locationVal}</div>
              </div>
            </AnimatedBlock>
            <AnimatedBlock delay={260}>
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-green-500 hover:bg-green-600 text-white px-8 py-4 rounded-full font-semibold transition-all hover:scale-105 shadow-lg">
                <MessageCircle className="mr-2 w-5 h-5" />{t.contact.cta}
              </a>
            </AnimatedBlock>
          </div>
          <AnimatedBlock delay={100} className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
            <ContactForm t={t} lang={lang} courseList={COURSE_TITLES_I18N[lang] || COURSE_TITLES_I18N.az} />
          </AnimatedBlock>
        </div>
      </div>
    </section>
  );
}
